import * as actions from './actions';
import reducers from './reducer';

export const Mix = { actions, reducers };
export { MixState } from './reducer';
